module.exports = __webpack_public_path__ + "static/media/icon-delete.b8ccbcff.svg";